module.exports = __webpack_public_path__ + "poster/error-template.jpg";